export const reviewPageEN =  {
	title: "Leave a Review",
	placeholder: "Share your experience...",
	anonymous: "Leave this review anonymously",
	submit: "Submit Review",
	submitting: "Submitting..."
}
